import { server_connection } from 'config';
import { setUserData } from '../../../../../auth/store/actions';
import { updateUserRoles } from '../../../../../auth/store/actions';

export const GET_COURSE_INFO = '[COURSE APP] GET COURSE INFO';
export const GET_COURSE_EVENTS = '[COURSE APP] GET COURSE EVENTS';
export const GET_COURSE_GRADEBOOK = '[COURSE APP] GET COURSE GRADEBOOK';
export const GET_COURSE_ASSETS = '[COURSE APP] GET COURSE ASSETS';
export const GET_COURSE_NOTIFICATIONS = '[COURSE APP] GET COURSE NOTIFICATIONS';
export const UPDATE_PAGE_LOADED = '[COURSE APP] UPDATE PAGE LOADED';
export const RESET_COURSE_DASHBOARD = '[COURSE APP] RESET COURSE DASHBOARD';
export const SELF_PACED_GET_NEXT_EVENT = '[COURSE APP] SELF PACED GET NEXT EVENT';
export const REMOVE_RESOLVED_NOTIFICATION = '[COURSE APP] REMOVE RESOLVED NOTIFICAITON';

export function getCourseInfo(company_calendar_course_id) {
    return (dispatch) => {
        fetch(server_connection + '/dashboard/course_dashboard/' + company_calendar_course_id)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_COURSE_INFO,
                    payload: responseData
                })
            })
    }
}

export function getCourseEvents(company_calendar_course_id, student_id, unscheduled) {
    return (dispatch) => {
        fetch(server_connection + '/scheduled_course/schedule/student/' + company_calendar_course_id + '/' + student_id + '/' + unscheduled)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_COURSE_EVENTS,
                    payload: responseData
                })
            })
    }
}


export function getCourseGradebook(student_id, company_calendar_course_id) {
    return (dispatch) => {
        fetch(server_connection + '/gradebook/get_student_gradebook',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ student_id, calendar_course_id: company_calendar_course_id })
            })
            .then((response) => response.json())
            .then((response) => {
                dispatch({
                    type: GET_COURSE_GRADEBOOK,
                    payload: response
                });
            });
    }
}

export function getCourseAssets(company_calendar_course_id) {
    return (dispatch) => {
        fetch(server_connection + '/scheduled_course/assets/' + company_calendar_course_id)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_COURSE_ASSETS,
                    payload: responseData
                })
            })
    }
}

export function getCourseNotifications(company_calendar_course_id, auth_id) {
    return (dispatch) => {
        fetch(server_connection + '/scheduled_course/notifications/' + company_calendar_course_id + '/' + auth_id)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_COURSE_NOTIFICATIONS,
                    payload: responseData
                })
            })
    }
}

export function selfPacedGetNextEvent(company_calendar_course_id, student_id) {
    return (dispatch) => {
        fetch(server_connection + '/scheduled_course/student_next_event/' + company_calendar_course_id + '/' + student_id)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: SELF_PACED_GET_NEXT_EVENT,
                    payload: responseData
                })
            })
    }
}

export function getCourseData(company_calendar_course_id, student_id, unscheduled, auth_id) {
    console.log(company_calendar_course_id, student_id, unscheduled)
    return (dispatch) => {
        Promise.all([
            dispatch(getCourseInfo(company_calendar_course_id)),
            dispatch(getCourseEvents(company_calendar_course_id, student_id, unscheduled)),
            dispatch(getCourseGradebook(student_id, company_calendar_course_id)),
            dispatch(getCourseAssets(company_calendar_course_id)),
            dispatch(getCourseNotifications(company_calendar_course_id, auth_id)),
            dispatch(selfPacedGetNextEvent(company_calendar_course_id, student_id))
        ]).then(
            () => dispatch(updatePageLoaded(true))
        )
    }
}



export function updatePageLoaded(setting) {
    return {
        type: UPDATE_PAGE_LOADED,
        payload: setting
    }
}

export function resetCourseDashboard() {
    return {
        type: RESET_COURSE_DASHBOARD,
    }
}

export function removeResolvedNotification(notification_rel_id) {
    return {
        type: REMOVE_RESOLVED_NOTIFICATION,
        payload: notification_rel_id
    }
}


// WEBPACK FOOTER //
// src/main/content/dashboard/store/actions/course.actions.js